import * as React from 'react';
export const arrowLeftSvg = React.forwardRef(function arrowLeftSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.72.97a.75.75 0 0 1 1.06 1.06L2.56 5.25h8.69a.75.75 0 0 1 0 1.5H2.56l3.22 3.22a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.748.748 0 0 1 0-1.06l4.5-4.5Z',
    }),
  );
});
arrowLeftSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowLeft = {
  category: 'icon',
  colorable: true,
  name: 'arrowLeft',
  svg: arrowLeftSvg,
};
